import React from 'react';

import styles from './IconRow.module.scss';

const { 'icon-row': iconRowClass, 'row-img': rowImgClass, 'row-body': rowBodyClass } = styles;

const IconRow = ({ icon = '', rowText = '', onClick = () => {} }) => {
  return (
    <div className={iconRowClass} {...{ onClick }}>
      {icon && <img className={rowImgClass} src={icon} alt="" />}
      <div className={rowBodyClass}>{rowText}</div>
    </div>
  );
};

export default IconRow;
